module.exports = __webpack_public_path__ + "static/img/r-3-1.e2b9148.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-3/r-3-1.png
// module id = MInN
// module chunks = 0